// @ts-check

import { S } from '../app/app_state.js?v=20260817c';
import {
  activeTool,
  clearActiveTool,
  setActiveTool
} from './tool_service.js?v=20260904f';

function ensureUi() {
  if (!S.ui || typeof S.ui !== 'object') S.ui = {};
  return S.ui;
}

function normalizeAllowedValues(values = []) {
  if (typeof values === 'function') return values;
  const allowed = new Set((Array.isArray(values) ? values : [...values || []]).map(value => String(value || '').trim()).filter(Boolean));
  return value => allowed.has(String(value || '').trim());
}

function validPlacementValue(value, values) {
  const normalized = String(value || '').trim();
  if (!normalized) return '';
  const isAllowed = normalizeAllowedValues(values);
  return isAllowed(normalized) ? normalized : '';
}

export function setPlacementTool(config = {}) {
  const systemId = String(config.systemId || '').trim();
  const uiKey = String(config.uiKey || '').trim();
  const value = validPlacementValue(config.value, config.values);
  if (!systemId || !uiKey || !value) return null;
  const metaKey = String(config.metaKey || 'value');
  const tool = typeof config.toolForValue === 'function'
    ? config.toolForValue(value)
    : String(config.tool || `insert-${value}`);
  const ui = ensureUi();
  ui[uiKey] = value;
  return setActiveTool({
    owner: systemId,
    tool,
    meta: {
      ...(config.meta && typeof config.meta === 'object' ? config.meta : {}),
      [metaKey]: value
    }
  });
}

export function activePlacementToolValue(config = {}) {
  const systemId = String(config.systemId || '').trim();
  const uiKey = String(config.uiKey || '').trim();
  const metaKey = String(config.metaKey || 'value');
  const active = activeTool();
  if (active?.owner === systemId) {
    const metaValue = validPlacementValue(active.meta?.[metaKey], config.values);
    if (metaValue) return metaValue;
  }
  return validPlacementValue(ensureUi()[uiKey], config.values);
}

export function clearPlacementTool(config = {}) {
  const systemId = String(config.systemId || '').trim();
  const uiKey = String(config.uiKey || '').trim();
  if (uiKey) ensureUi()[uiKey] = null;
  if (systemId) clearActiveTool(systemId);
  return true;
}

export function syncPlacementToolFromLegacy(config = {}) {
  const systemId = String(config.systemId || '').trim();
  const uiKey = String(config.uiKey || '').trim();
  const metaKey = String(config.metaKey || 'value');
  const value = validPlacementValue(ensureUi()[uiKey], config.values);
  if (!systemId || !uiKey || !value) return null;
  const tool = typeof config.toolForValue === 'function'
    ? config.toolForValue(value)
    : String(config.tool || `insert-${value}`);
  return {
    owner: systemId,
    tool,
    meta: {
      ...(config.meta && typeof config.meta === 'object' ? config.meta : {}),
      [metaKey]: value
    }
  };
}

